import ScaleIcon from "@redotech/redo-icons/scales-01.svg";
import { BooleanFilterOperator } from "@redotech/redo-model/views/advanced-filters/boolean-filter";
import { AdvancedFilterType } from "@redotech/redo-model/views/advanced-filters/generic-advanced-filter-data";
import { BooleanTableFilter } from "@redotech/redo-web/advanced-filters/advanced-filter";

export const UsedWeightLearningFilter: BooleanTableFilter = {
  type: AdvancedFilterType.BOOLEAN,
  data: {
    name: "usedWeightLearning",
    type: AdvancedFilterType.BOOLEAN,
    value: null,
    operator: BooleanFilterOperator.IS,
  },
  Icon: ScaleIcon,
  displayName: "Used weight learning",
  label: "Weight learning",
  boolDisplay: { falseDisplay: "not used", trueDisplay: "used" },
};
